import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "./alaram.mp3";
import { ClipLoader } from "react-spinners";
import "./Cateringsreport.css";
const Cateringsordersscroll = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const scrollContainerRef = useRef(null);
    const notificationSound = new Audio(sound);

    // Get vendorId from localStorage
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);
    const handleAcceptOrderr = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken"); // ✅ Retrieve token
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            // Build the URL with query params
            const url = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/orders/status?orderId=${orderId}&orderStatus=PREPARING&cancelReason=`;

            const response = await axios.put(url, null, {
                headers: {
                    Authorization: `Bearer ${token}`, // ✅ Add token to headers
                    Accept: "*/*",
                },
            });

            console.log("Status updated:", response.data);

            // Remove the order from UI
            setOrders(prev => prev.filter(order => order.orderId !== orderId));
        } catch (error) {
            console.error("Failed to update order status:", error.response?.data || error.message);
            alert("Failed to accept order");
        }
    };

    const handleCancelOrder = async (e, orderId, cancelReason = "") => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }
        cancelReason = "asdasdf"
        try {
            // Build the URL with query params
            const url = `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/orders/status?orderId=${orderId}&orderStatus=CANCELLED&cancelReason=${encodeURIComponent(cancelReason)}`;

            const response = await axios.put(url, null, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            });

            console.log("Order cancelled:", response.data);

            // Remove the order from UI
            setOrders(prev => prev.filter(order => order.orderId !== orderId));
        } catch (error) {
            console.error("Failed to cancel order:", error.response?.data || error.message);
            alert("Failed to cancel order");
        }
    };


    // Fetch confirmed orders
    const fetchOrders = async () => {
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            console.warn("vendorId or token is missing!");
            setLoading(false);
            return;
        }

        try {
            const res = await axios.get(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/getall/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Filter only confirmed orders
            const confirmedOrders = res.data
                .filter(order => order.orderStatus === "CONFIRMED")
                .map(order => ({
                    ...order,
                    itemsList: order.orderItems.flatMap(orderItem =>
                        orderItem.packageItems.map(item => ({
                            itemId: item.itemId,
                            dishName: item.itemName,
                            quantity: orderItem.quantity,
                            listId: `${order.orderId}-${item.itemId}`, // unique ID for checkbox/cancel
                        }))
                    ),
                }));

            // 🔔 Check for new orders before updating state
            const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
            const newOrders = confirmedOrders.filter(
                (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
            );

            if (newOrders.length > 0) {
                // Play notification sound
                notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
            }

            // Update state
            setOrders(confirmedOrders);
        } catch (error) {
            console.error("Error fetching orders:", error);
            alert("Error fetching orders: " + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    // Fetch orders when vendorId changes
    useEffect(() => {
        if (vendorId) fetchOrders();
    }, [vendorId]);

    // Auto-scroll
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        const interval = setInterval(() => {
            if (!isHovered) {
                scrollContainer.scrollTop += 1;
                if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                    scrollContainer.scrollTop = 0;
                }
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isHovered]);

    // Expand/collapse order
    const handleOrderClick = order => {
        const id = order.orderId;
        setExpandedOrder(prev => (prev?.id === id ? null : { ...order, id }));
    };

    // Checkbox toggle
    const handleCheckboxChange = itemId => {
        setSelectedItems(prev => ({ ...prev, [itemId]: !prev[itemId] }));
    };

    // Cancel single item
    const handleCancelSingleOrder = async listId => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Auth token not found!");
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/food/orderscancellationlist/edit/${listId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ status: "Cancelled" }),
                }
            );

            if (!response.ok) {
                alert(`Failed to cancel order ${listId}`);
            } else {
                alert(`Order ${listId} cancelled successfully.`);
                setSelectedItems(prev => {
                    const updated = { ...prev };
                    delete updated[listId];
                    return updated;
                });
            }
        } catch (error) {
            console.error("Error cancelling order:", error);
        }
    };

    const getOrderColor = orderStatus => {
        switch ((orderStatus || "").trim().toLowerCase()) {
            case "dine_in":
                return "#1E90FF";
            case "CONFIRMED":
                return "#FF6347";
            case "delivery":
                return "#20B2AA";
            case "table_dine_in":
                return "#2051b2ff";
            default:
                return "#FF6347";
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: "130px",
                bottom: "20px",
                right: "16px",
                borderRadius: "8px",
                padding: "10px",
                display: "flex",
                flexDirection: "column",
            }}


            className="orders-scroll-data"
        >
            <div
                style={{
                    flexGrow: 1,
                    overflowY: "auto",
                    paddingRight: "5px",
                }}
                ref={scrollContainerRef}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {loading ? (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                        <ClipLoader color="#ff4081" size={60} />
                    </div>
                ) : orders.length === 0 ? (
                    <p style={{ textAlign: "center", color: "#FF6347" }}>No confirmed orders found.</p>
                ) : (
                    orders.map((order, index) => {
                        const uniqueId = order.orderId;
                        const isExpanded = expandedOrder?.id === uniqueId;
                        const itemsList = order.itemsList || [];

                        return (
                            <div
                                key={uniqueId}
                                onClick={() => handleOrderClick(order)}
                                style={{
                                    cursor: "pointer",
                                    width: "300px",
                                    marginBottom: "10px",
                                    background: getOrderColor(order.orderStatus),
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                    padding: "10px",
                                    transition: "all 0.3s ease",
                                    height: isExpanded ? "auto" : "120px",
                                    position: "relative",
                                }}
                            >
                                <div>
                                    {/* Header */}
                                    <div style={{ display: "flex", justifyContent: "space-between", color: "#fff", fontWeight: "bold" }}>
                                        <p>Order ID: #{uniqueId}</p>
                                        <h5>{order.orderType || "N/A"}</h5>
                                    </div>

                                    {/* Items List (Expandable) */}
                                    {isExpanded && (
                                        <div style={{ marginTop: "10px" }}>
                                            <h6 style={{ color: "#fff", fontSize: "20px" }}>Items:</h6>
                                            <ul style={{ listStyle: "none", padding: 0, marginLeft: "10px" }}>
                                                {itemsList.map(item => (
                                                    <li
                                                        key={item.listId}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            color: "#000",
                                                            fontSize: "16px",
                                                            marginBottom: "8px",
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={!!selectedItems[item.listId]}
                                                            onChange={e => {
                                                                e.stopPropagation();
                                                                handleCheckboxChange(item.listId);
                                                            }}
                                                            style={{ marginRight: "10px" }}
                                                        />
                                                        <span>{item.dishName} × {item.quantity}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {/* Accept & Decline Buttons (Always visible outside items list) */}
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: "10px",
                                    }}>
                                        <button
                                            onClick={(e) => handleAcceptOrderr(e, uniqueId)}
                                            style={{
                                                padding: "8px",
                                                backgroundColor: "rgb(177 93 198)",
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Accept
                                        </button>

                                        <button
                                            onClick={(e) => handleCancelOrder(e, uniqueId)}
                                            style={{
                                                padding: "8px",
                                                backgroundColor: "rgb(177 93 198)",
                                                color: "white",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Decline
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}


            </div>
        </div >
    );
};

export default Cateringsordersscroll;
